import {ReactNode} from 'react';

export function BadgeList({children}: {children: ReactNode}) {
  return (
    <div className="mb-4pxr flex shrink-0 flex-wrap items-start pt-18pxr [&>*:not(:last-child)]:mr-4pxr">
      {children}
    </div>
  );
}
